import { PHASES, countersForPlayerCount } from '../constants';
import { dealRound } from '../state/createGameState';

/**
 * Deals the next round of a multi-round match - a HOUSE RULE, not the
 * rulebook's (see constants.js, MAX_ROUNDS).
 *
 * Every round is a complete rulebook game: a fresh shuffle with nine cards
 * put back unseen (p1, Set Up 1-2), a full counter supply again (Set Up 3),
 * and empty hands. The only things carried over are the banked round scores
 * (state.roundResults) and the RNG, so a seed still replays the whole match.
 *
 * The first player moves one seat to the left each round, so nobody opens
 * every round - the same way play itself passes (p2, Game Play 2).
 *
 * Only legal between rounds; anything else returns the state unchanged.
 */
export const nextRound = (state) => {
  if (state.meta.phase !== PHASES.ROUND_OVER) return state;

  const { deck, currentCard, rngState } = dealRound(state.meta.rngState);
  const counters = countersForPlayerCount(state.players.length);
  const firstSeat = ((state.meta.startingPlayerIndex ?? 0) + 1) % state.players.length;
  const round = (state.meta.round ?? 1) + 1;

  return {
    ...state,
    meta: {
      ...state.meta,
      phase: PHASES.PLAYING,
      rngState,
      round,
      activePlayerIndex: firstSeat,
      startingPlayerIndex: firstSeat,
      turn: state.meta.turn + 1,
      seq: (state.meta.seq || 0) + 1,
    },
    deck,
    currentCard,
    countersOnCard: 0,
    players: state.players.map((p) => ({ ...p, counters, cards: [] })),
    roundResults: [...(state.roundResults || [])],
    log: [...state.log, {
      kind: 'roundStart',
      round,
      firstPlayer: state.players[firstSeat]?.name,
      card: currentCard,
    }],
  };
};
